import { useEffect, useState } from 'react';

import css from './AddContract.module.css';

import * as contractServices from '../../../../services/contractService.js';
import toShort from '../../../../services/utils/dateParser.js';

function AddContract({ onAdd, onClose, func = 'Add', data }) {
    const [options, setOptions] = useState();
    const [filteredCustomers, setFilteredCustomers] = useState([]);
    const template = {
        contractId: data?.contractId || 999999,
        contractTitle: data?.contractTitle || '',
        customerId: data?.customerId || 5,
        contractDate: toShort(data?.contractDate, 1) || '2024-09-19',
        contractRequests: data?.contractRequests || 0,
        documentStatusId: data?.documentStatusId || 1,
        paymentStatusId: data?.paymentStatusId || 1,
        contractTotalAmount: data?.contractTotalAmount || 0,
        contractNotes: data?.contractNotes || '',
        contractLink: data?.contractLink || '',
        contractStatusId: data?.contractStatusId || 1,
    };
    console.log(template);
    
    const [newData, setNewData] = useState(template);

    useEffect(() => {
        Promise.all([
            contractServices.getOption('customersData'),
            contractServices.getOption('contractStatus'),
            contractServices.getOption('contractDocumentStatus'),
            contractServices.getOption('contractPaymentStatus'),
        ])
            .then((res) => {
                // console.log(res);
                const [customers, status, document, payment] = res;
                const optionsRes = { customers, status, document, payment };
                // console.log(optionsRes);

                setOptions(optionsRes);
                setFilteredCustomers(customers.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const onChange = (e) => {
        let id = e.currentTarget.id;
        let value = e.currentTarget.value;
        setNewData((st) => ({ ...st, [id]: value }));
    };

    const filterCustomers = (e) => {
        let value = e.currentTarget.value;

        const filteredArr = options.customers.data.filter((x) => x.customerName.toLowerCase().includes(value.toLowerCase()));
        setFilteredCustomers(filteredArr);
        if (filteredArr.length) {
            setNewData((st) => ({ ...st, customerId: filteredArr[0].customerId }));
            console.log(filteredArr[0].customerId);
        } else {
            console.log('No results');
        }
    };

    return (
        <form>
            {func === 'Add' ? <h3>Add new contract</h3> : <h3>Edit contract</h3>}
            <div className={css.formArea}>
                <div className={css.inputs}>
                    <label htmlFor="contractTitle">
                        Title
                        <input type="text" id="contractTitle" onChange={onChange} value={newData.contractTitle} />
                    </label>
                    <div className={css.group}>
                        <div>
                            <label htmlFor="contractRequests">Requests</label>
                            <input type="number" id="contractRequests" onChange={onChange} value={newData.contractRequests} />
                        </div>
                        <div>
                            <label htmlFor="contractTotalAmount">Amount (BGN)</label>
                            <input type="number" id="contractTotalAmount" onChange={onChange} value={newData.contractTotalAmount} />
                        </div>

                        <div>
                            <label htmlFor="contractDate">Date</label>
                            <input type="date" id="contractDate" onChange={onChange} value={newData.contractDate} />
                        </div>
                    </div>

                    <label htmlFor="contractLink">Link</label>
                    <input type="text" id="contractLink" onChange={onChange} value={newData.contractLink} />

                    <label htmlFor="customerId">Customer</label>
                    <div className={css.group}>
                        <select id="customerId" onChange={onChange} value={newData.customerId}>
                            {filteredCustomers.map((x) => (
                                <option key={x.customerId} value={x.customerId}>
                                    {x.customerName}
                                </option>
                            ))}
                        </select>
                        <input type="text" onChange={filterCustomers} />
                    </div>

                    <label htmlFor="contractStatusId">Contract status</label>
                    <select id="contractStatusId" onChange={onChange} value={newData.contractStatusId}>
                        {options?.status.data.map((x) => (
                            <option key={x.contractStatusId} value={+x.contractStatusId}>
                                {x.contractStatusTitle}
                            </option>
                        ))}
                    </select>

                    <label htmlFor="documentStatusId">Document</label>
                    <select id="documentStatusId" onChange={onChange} value={newData.documentStatusId}>
                        {options?.document.data.map((x) => (
                            <option key={x.contractDocumentStatusId} value={+x.contractDocumentStatusId}>
                                {x.contractDocumentStatusTitle}
                            </option>
                        ))}
                    </select>

                    <label htmlFor="paymentStatusId">Payment</label>
                    <select id="paymentStatusId" onChange={onChange} value={newData.paymentStatusId}>
                        {options?.payment.data.map((x) => (
                            <option key={x.contractPaymentStatusId} value={+x.contractPaymentStatusId}>
                                {x.contractPaymentStatusTitle}
                            </option>
                        ))}
                    </select>
                </div>

                <div className={css.textArea}>
                    <label htmlFor="contractNotes">Notes</label>
                    <textarea id="contractNotes" cols="45" rows="30" onChange={onChange} value={newData.contractNotes} />
                </div>

                <div className={css.buttons}>
                    {func === 'Add' ? (
                        <button className={css.add} onClick={(e) => onAdd(e, newData)}>
                            Add
                        </button>
                    ) : (
                        <button className={css.edit} onClick={(e) => onAdd(e, newData)}>
                            Edit
                        </button>
                    )}
                    <button className={css.close} onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </form>
    );
}

export default AddContract;
